import { useContext } from 'react'

import { Screen } from '../../../../../context'
import { useKeyboard } from '../../../../../hooks'
import { MINIMIZED_MODAL_SCOPE } from '../../../../Modal'
import {
  PREVIEW_VIEW_TYPE_MIN_SCREEN_WIDTH,
  useMultipleViewTypeList,
} from '../../../../MultipleViewTypeList'
import { getListingProfileLink } from '../../../../RentalPortalListing'

import { isSplitPaneEscapeClaimed } from './useRentalPortalListingsMultipleViewTypeList.utils'

export function useRentalPortalListingsMultipleViewTypeList({
  handleReload,
  handleSetPreview,
  handleSetView,
  handleUpdateConfig,
  items,
  listViewType,
  preview,
}) {
  const { width } = useContext(Screen)

  const multipleViewTypeList = useMultipleViewTypeList({
    getProfileLink: getListingProfileLink,
    handleReload,
    handleSetPreview,
    handleSetView,
    handleUpdateConfig,
    items,
    listViewType,
    minimizedModalScope: MINIMIZED_MODAL_SCOPE.RENTAL_PORTAL_LISTING_PROFILE,
    preview,
  })

  function handleEscape() {
    if (!isSplitPaneEscapeClaimed()) {
      multipleViewTypeList.handleResetViewTypeToPlainBody()
    }
  }

  useKeyboard(null, handleEscape)

  return {
    ...multipleViewTypeList,
    isSplitAvailable: width > PREVIEW_VIEW_TYPE_MIN_SCREEN_WIDTH,
  }
}
